import React from 'react';

/**
 * Tracking-Linie vom letzten Punkt zur Maus (Rhino-Style "Rubber Band").
 * Zeigt die Verbindung zwischen dem zuletzt gesetzten Punkt und der
 * aktuellen Mausposition an.
 */
export function TrackingLine({ lastPoint, mousePosition, orthoMode, activeTool }) {
  // Nur anzeigen wenn es einen lastPoint gibt und wir im richtigen Tool sind
  if (!lastPoint || !mousePosition) return null;
  const trackingTools = ['point', 'wall', 'space', 'shaft', 'stub_wall', 'arc'];
  if (!trackingTools.includes(activeTool)) return null;

  // Ortho-Modus: Nur horizontal oder vertikal
  let targetX = mousePosition.x;
  let targetY = mousePosition.y;

  if (orthoMode) {
    const dx = Math.abs(mousePosition.x - lastPoint.x);
    const dy = Math.abs(mousePosition.y - lastPoint.y);
    if (dx > dy) {
      targetY = lastPoint.y; // Horizontal
    } else {
      targetX = lastPoint.x; // Vertikal
    }
  }

  return (
    <group>
      {/* Tracking-Linie */}
      <line>
        <bufferGeometry>
          <bufferAttribute
            attach="attributes-position"
            count={2}
            array={new Float32Array([
              lastPoint.x, lastPoint.y, 8,
              targetX, targetY, 8
            ])}
            itemSize={3}
          />
        </bufferGeometry>
        <lineBasicMaterial color="#f59e0b" linewidth={1} transparent opacity={0.8} />
      </line>

      {/* Gestrichelte Hilfslinie bei Ortho (zeigt echte Mausposition) */}
      {orthoMode && (Math.abs(mousePosition.x - targetX) > 10 || Math.abs(mousePosition.y - targetY) > 10) && (
        <line>
          <bufferGeometry>
            <bufferAttribute
              attach="attributes-position"
              count={2}
              array={new Float32Array([
                targetX, targetY, 7,
                mousePosition.x, mousePosition.y, 7
              ])}
              itemSize={3}
            />
          </bufferGeometry>
          <lineBasicMaterial color="#94a3b8" linewidth={1} transparent opacity={0.3} />
        </line>
      )}
    </group>
  );
}

export default TrackingLine;
